import { Component, OnInit } from '@angular/core';
import { environment } from '../../../environments/environment';

@Component({
  selector: 'app-page-agb',
  templateUrl: './page-agb.component.html',
  styleUrls: ['./page-agb.component.css']
})
export class PageAgbComponent implements OnInit {

  constructor(
  ) { }

  ngOnInit() {
  }

  get shopCountry(): string {
    return environment.globalSettings.shopCountry;
  }
}
